const SERVICE_PATH = 'rest/game-center-service';
const VERSION = 'v1';

export const ApiServicePath = {
  GAME_CENTER_PLAYERS: `${SERVICE_PATH}/${VERSION}/game-center-players`,
  GAME_CENTER_PLAYER_VERIFICATION: `${SERVICE_PATH}/${VERSION}/game-center-player-verification`,
  GAME_CENTER_COUPON_REDEEMS: `${SERVICE_PATH}/${VERSION}/game-center-coupon-redeems`,
};
